import styled from 'styled-components';
import { StyledDiv } from '../../Theme/CommonStyled';

export const StyledLoginContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 50px;
  height: 518px;
`;

export const StyledMobileInputContainer = styled.div`
  margin-top: 180px;
  //margin-bottom: 100px;
`;

export const StyledPhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 64px 0;
`;

export const StyledCountDown = styled.div`
  font-family: IRANSans;
  text-align: center;
  direction: rtl;
  margin-top: 65px;
  height: 86px;
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  color: ${({ theme }): string => theme.colors.normalText};
`;

export const StyledResendCode = styled(StyledDiv)`
  margin-top: 65px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: rtl;
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  color: ${({ theme }): string => theme.colors.normalText};
`;
